module.exports = __webpack_public_path__ + "img/goods1.a4fe8c3b.png";